'use client';

import { PortableText } from '@portabletext/react';
import { useState } from 'react';
import type { FaqEntry } from '@/helpers/faq';
import { faqAnswerComponents } from '@/helpers/portable-text';
import SvgArrowDown from './svg/SvgArrowDown';

export default function AccordionFaq({ items }: { items: FaqEntry[] }) {
    const [activeItem, setActiveItem] = useState<number | null>(null);

    return (
        <>
            {items.map(({ question, answer }, key) => (
                <article
                    key={question}
                    className={`bg-white rounded-[35px] ${
                        key < 3 ? 'accent-blue-800' : 'accent-orange-800'
                    }`}
                >
                    <div className="w-full bg-linear-to-tr from-accent-color to-accent-color/50 text-white rounded-[35px]">
                        <h3>
                            <button
                                type="button"
                                className="w-full flex items-center justify-between gap-4 cursor-pointer py-6 pl-10 pr-6 text-left text-md md:text-lg font-semibold"
                                onClick={() => (key === activeItem ? setActiveItem(null) : setActiveItem(key))}
                                aria-expanded={key === activeItem}
                                aria-controls={`faq-panel-${key}`}
                            >
                                <span>{question}</span>
                                <span
                                    className="w-14 h-14 bg-white/25 shrink-0 rounded-full inline-flex items-center justify-center"
                                    aria-hidden="true"
                                >
                                    <SvgArrowDown
                                        width={18}
                                        className={`transform transition-transform duration-500 ${
                                            key === activeItem ? 'rotate-180' : ''
                                        }`}
                                    />
                                </span>
                            </button>
                        </h3>
                        <div
                            id={`faq-panel-${key}`}
                            className={`accordion ${key === activeItem ? 'accordion-open' : ''}`}
                        >
                            <div className="pt-0 pb-12 pl-10 pr-6 max-w-[790px] flex flex-col gap-8">
                                <PortableText value={answer} components={faqAnswerComponents} />
                            </div>
                        </div>
                    </div>
                </article>
            ))}
        </>
    );
}
